import { isApplePayAvailableAsPaymentMethod } from '../selectors/order';
import { CheckoutState } from '../state';
import { isApplePaySupported } from '../utils/applePay';
import { isEventbriteTLDInDevOrQAEnv, isIosApp } from '../utils/browser';
import { ENABLE_APPLE_PAY } from '../utils/splitio';
import { isEventbriteTLD } from './app';
import { isSplitTreatmentEnabled } from './splitio';

export const isTLDWithApplePayEnabled = (state: CheckoutState) =>
    isEventbriteTLD(state) || isEventbriteTLDInDevOrQAEnv() || isIosApp(state);

export const isApplePayEnabled = (state: CheckoutState) =>
    isApplePayAvailableAsPaymentMethod(state) &&
    isTLDWithApplePayEnabled(state) &&
    isSplitTreatmentEnabled(state, ENABLE_APPLE_PAY) &&
    isApplePaySupported();

export const isApplePaySortedAndPreselected = (state: CheckoutState) =>
    !!state.applepay?.canMakePaymentsWithActiveCard;

export const isApplePayInstanceCreated = (state: CheckoutState) =>
    !!state.applepay?.applepayInstance;
